import { useAppSelector } from '../../../hook/useAppSelector';
import { getMoneyClass } from '../../../util/formatCurrencySymbol';
import { numberFormatter } from '../../../util/numberFormatter';

interface MoneyRowProps {
  label: string;
  amount: number;
  className?: string;
}
const MoneyRow: React.FC<MoneyRowProps> = ({ label, amount, className }) => {
  const selectedCCY = useAppSelector((state) => state.cashRegisterData.selectedCCY);
    const format = useAppSelector((state) => state.configSlice.format);

  return (
    <div className={`value_row ${className}`}>
      <span className="label">{label}</span>
      <span className={`money_container ${getMoneyClass(selectedCCY)}`}>
        <span className="balance">{numberFormatter(Number(amount), format)}</span>
        <span className="currency"> {selectedCCY}</span>
      </span>
    </div>
  );
};

export default MoneyRow;
